  // 色一括削除
  const handleBulkDeleteColor = async (ids) => {
    if (!user) return;
    for (const id of ids) {
      await deleteColorFromFirestore(id, user.uid);
    }
    setColors(colors.filter(c => !ids.includes(c.id)));
  };
  // ジャンル一括削除
  const handleBulkDeleteGenre = async (ids) => {
    if (!user) return;
    for (const id of ids) {
      await deleteGenreFromFirestore(id, user.uid);
    }
    setGenres(genres.filter(g => !ids.includes(g.id)));
  };
  // 道具状態一括削除
  const handleBulkDeleteToolState = async (ids) => {
    if (!user) return;
    for (const id of ids) {
      await deleteStateFromFirestore(id);
    }
    setToolStates(toolStates.filter(s => !ids.includes(s.id)));
  };
import React, { useState } from 'react';
import ListManager from '../../Components/ListManager/ListManager';
import styles from './ToolSettings.module.css';
import { useAuth } from '../../firebase/AuthContext';
import { addBrandToFirestore, getBrandsFromFirestore, deleteBrandFromFirestore } from '../../firebase/brandService';
import { addGenreToFirestore, getGenresFromFirestore, deleteGenreFromFirestore } from '../../firebase/genreService';
import { addColorToFirestore, getColorsFromFirestore, deleteColorFromFirestore } from '../../firebase/colorService';
import { addStateToFirestore, getStatesFromFirestore, deleteStateFromFirestore } from '../../firebase/stateService';

const ToolSettings = () => {
  const { user } = useAuth();
  // ブランド
  const [brandName, setBrandName] = useState('');
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  // ジャンル
  const [genreName, setGenreName] = useState('');
  const [genres, setGenres] = useState([]);
  const [genreLoading, setGenreLoading] = useState(true);
  // 色
  const [colorName, setColorName] = useState('');
  const [colors, setColors] = useState([]);
  const [colorLoading, setColorLoading] = useState(true);

  // 道具用状態
  const [toolStateName, setToolStateName] = useState('');
  const [toolStates, setToolStates] = useState([]);
  const [toolStateLoading, setToolStateLoading] = useState(true);
  // 投稿用状態
  const [postStateName, setPostStateName] = useState('');
  const [postStates, setPostStates] = useState([]);
  const [postStateLoading, setPostStateLoading] = useState(true);
  // 残量状態
  const [stockStateName, setStockStateName] = useState('');
  const [stockStates, setStockStates] = useState([]);
  const [stockStateLoading, setStockStateLoading] = useState(true);

  React.useEffect(() => {
    if (!user) return;
    (async () => {
      setLoading(true);
      const data = await getBrandsFromFirestore(user.uid);
      setBrands(data);
      setLoading(false);
    })();
    (async () => {
      setGenreLoading(true);
      const data = await getGenresFromFirestore(user.uid);
      setGenres(data);
      setGenreLoading(false);
    })();
    (async () => {
      setColorLoading(true);
      const data = await getColorsFromFirestore(user.uid);
      setColors(data);
      setColorLoading(false);
    })();
    (async () => {
      setToolStateLoading(true);
      const data = await getStatesFromFirestore(user.uid, 'tool');
      setToolStates(data);
      setToolStateLoading(false);
    })();
    (async () => {
      setPostStateLoading(true);
      const data = await getStatesFromFirestore(user.uid, 'post');
      setPostStates(data);
      setPostStateLoading(false);
    })();
    (async () => {
      setStockStateLoading(true);
      const data = await getStatesFromFirestore(user.uid, 'stock');
      setStockStates(data);
      setStockStateLoading(false);
    })();
  }, [user]);

  // 残量状態追加・削除
  const handleAddStockState = async (e) => {
    e.preventDefault();
    if (!stockStateName.trim() || !user) return;
    const id = await addStateToFirestore(stockStateName.trim(), user.uid, 'stock');
    setStockStates([...stockStates, { id, name: stockStateName.trim(), uid: user.uid, type: 'stock' }]);
    setStockStateName('');
  };
  const handleRemoveStockState = async (idx) => {
    if (!user) return;
    const state = stockStates[idx];
    await deleteStateFromFirestore(state.id);
    setStockStates(stockStates.filter((_, i) => i !== idx));
  };
  // 道具用状態追加・削除
  const handleAddToolState = async (e) => {
    e.preventDefault();
    if (!toolStateName.trim() || !user) return;
    const id = await addStateToFirestore(toolStateName.trim(), user.uid, 'tool');
    setToolStates([...toolStates, { id, name: toolStateName.trim(), uid: user.uid, type: 'tool' }]);
    setToolStateName('');
  };
  const handleRemoveToolState = async (idx) => {
    if (!user) return;
    const state = toolStates[idx];
    await deleteStateFromFirestore(state.id);
    setToolStates(toolStates.filter((_, i) => i !== idx));
  };
  // 投稿用状態追加・削除
  const handleAddPostState = async (e) => {
    e.preventDefault();
    if (!postStateName.trim() || !user) return;
    const id = await addStateToFirestore(postStateName.trim(), user.uid, 'post');
    setPostStates([...postStates, { id, name: postStateName.trim(), uid: user.uid, type: 'post' }]);
    setPostStateName('');
  };
  const handleRemovePostState = async (idx) => {
    if (!user) return;
    const state = postStates[idx];
    await deleteStateFromFirestore(state.id);
    setPostStates(postStates.filter((_, i) => i !== idx));
  };

  // ブランド追加・削除
  const handleAddBrand = async (e) => {
    e.preventDefault();
    if (!brandName.trim() || !user) return;
    const id = await addBrandToFirestore(brandName.trim(), user.uid);
    setBrands([...brands, { id, name: brandName.trim(), uid: user.uid }]);
    setBrandName('');
  };
  const handleRemoveBrand = async (idx) => {
    if (!user) return;
    const brand = brands[idx];
    await deleteBrandFromFirestore(brand.id, user.uid);
    setBrands(brands.filter((_, i) => i !== idx));
  };
  // ブランド一括削除
  const handleBulkDeleteBrand = async (ids) => {
    if (!user) return;
    for (const id of ids) {
      await deleteBrandFromFirestore(id, user.uid);
    }
    setBrands(brands.filter(b => !ids.includes(b.id)));
  };
  // 色追加・削除
  const handleAddColor = async (e) => {
    e.preventDefault();
    if (!colorName.trim() || !user) return;
    const id = await addColorToFirestore(colorName.trim(), user.uid);
    setColors([...colors, { id, name: colorName.trim(), uid: user.uid }]);
    setColorName('');
  };
  const handleRemoveColor = async (idx) => {
    if (!user) return;
    const color = colors[idx];
    await deleteColorFromFirestore(color.id, user.uid);
    setColors(colors.filter((_, i) => i !== idx));
  };
  // ジャンル追加・削除
  const handleAddGenre = async (e) => {
    e.preventDefault();
    if (!genreName.trim() || !user) return;
    const id = await addGenreToFirestore(genreName.trim(), user.uid);
    setGenres([...genres, { id, name: genreName.trim(), uid: user.uid }]);
    setGenreName('');
  };
  const handleRemoveGenre = async (idx) => {
    if (!user) return;
    const genre = genres[idx];
    await deleteGenreFromFirestore(genre.id, user.uid);
    setGenres(genres.filter((_, i) => i !== idx));
  };

  return (
    <div className={styles.container}>
      <h2 style={{marginBottom:24}}>道具に関する設定</h2>
      {/* ブランド管理 */}
      <div style={{marginBottom:32}}>
        <ListManager
          title="ブランド管理"
          label="ブランド"
          description="作品や道具のブランド名を追加・削除できます。"
          inputForm={
            <form onSubmit={handleAddBrand} style={{display:'flex',gap:8,marginTop:12}}>
              <input
                type="text"
                value={brandName}
                onChange={e => setBrandName(e.target.value)}
                placeholder="ブランド名を入力"
                className={styles.input}
              />
              <button type="submit" className={styles.button}>追加</button>
            </form>
          }
          items={brands}
          onRemove={handleRemoveBrand}
          onBulkRemove={handleBulkDeleteBrand}
          loading={loading}
        />
      </div>
      {/* 色管理 */}
      <div style={{marginBottom:32}}>
        <ListManager
          title="色管理"
          label="色"
          description="作品や道具で使う色を追加・削除できます。"
          inputForm={
            <form onSubmit={handleAddColor} style={{display:'flex',gap:8,marginTop:12}}>
              <input
                type="text"
                value={colorName}
                onChange={e => setColorName(e.target.value)}
                placeholder="色名を入力"
                className={styles.input}
              />
              <button type="submit" className={styles.button}>追加</button>
            </form>
          }
          items={colors}
          onRemove={handleRemoveColor}
          onBulkRemove={handleBulkDeleteColor}
          loading={colorLoading}
        />
      </div>
      {/* ジャンル管理 */}
      <div style={{marginBottom:32}}>
        <ListManager
          title="ジャンル管理"
          label="ジャンル"
          description="作品や道具のジャンル（カテゴリ）を追加・削除できます。"
          inputForm={
            <form onSubmit={handleAddGenre} style={{display:'flex',gap:8,marginTop:12}}>
              <input
                type="text"
                value={genreName}
                onChange={e => setGenreName(e.target.value)}
                placeholder="ジャンル名を入力"
                className={styles.input}
              />
              <button type="submit" className={styles.button}>追加</button>
            </form>
          }
          items={genres}
          onRemove={handleRemoveGenre}
          onBulkRemove={handleBulkDeleteGenre}
          loading={genreLoading}
        />
      </div>
      {/* 道具の状態管理 */}
      <div style={{marginBottom:32}}>
        <ListManager
          title="道具の状態管理"
          label="道具の状態"
          description="道具で使う状態（例：未使用、使用中、壊れた等）を追加・削除できます。"
          inputForm={
            <form onSubmit={handleAddToolState} style={{display:'flex',gap:8,marginTop:12}}>
              <input
                type="text"
                value={toolStateName}
                onChange={e => setToolStateName(e.target.value)}
                placeholder="道具の状態名を入力"
                className={styles.input}
              />
              <button type="submit" className={styles.button}>追加</button>
            </form>
          }
          items={toolStates}
          onRemove={handleRemoveToolState}
          onBulkRemove={handleBulkDeleteToolState}
          loading={toolStateLoading}
        />
      </div>
      {/* 残量の状態管理 */}
      <div style={{marginBottom:32}}>
        <ListManager
          title="残量の状態管理"
          label="残量の状態"
          description="道具の残量状態（例：満タン、半分、空など）を追加・削除できます。"
          inputForm={
            <form onSubmit={handleAddStockState} style={{display:'flex',gap:8,marginTop:12}}>
              <input
                type="text"
                value={stockStateName}
                onChange={e => setStockStateName(e.target.value)}
                placeholder="残量の状態名を入力"
                className={styles.input}
              />
              <button type="submit" className={styles.button}>追加</button>
            </form>
          }
          items={stockStates}
          onRemove={handleRemoveStockState}
          loading={stockStateLoading}
        />
      </div>
    </div>
  );
};

export default ToolSettings;
